﻿'use strict';

/**
* Working with bootstrap autocomplete.
*
* @example <input type="text" ng-model="" uib-typeahead="" typeahead-template-url="" typeahead />
*/
angular.module('ntmApp')
  .directive('typeahead', function () {
      return {
          require: 'ngModel',
          link: function (scope, element, attr, ctrl) {
              element.bind('click', function () {

                  var currentValue = ctrl.$viewValue || '';
                  ctrl.$setViewValue(' ');
                  ctrl.$setViewValue(currentValue);
                  $(this).focus();
              });
          }
      };
  });